import React, { useState } from 'react';
import { Avatar, AvatarProps } from '@mui/material';
import { DEFAULT_AVATAR } from '../../features/constants/avatars';

interface AvatarImageProps extends Omit<AvatarProps, 'src'> {
  avatarUrl?: string | null;
  size?: number;
}

const AvatarImage: React.FC<AvatarImageProps> = ({ 
  avatarUrl, 
  size = 40,
  ...avatarProps 
}) => {
  const [hasError, setHasError] = useState(false);
  return (
    <Avatar
      {...avatarProps}
      src={hasError ? DEFAULT_AVATAR : (avatarUrl || DEFAULT_AVATAR)}
      onError={() => setHasError(true)}
      sx={{
        width: size,
        height: size,
        ...avatarProps.sx,
        '& img': {
          objectFit: 'cover',
          width: '100%',
          height: '100%'
        }
      }}
    />
  );
};

export default AvatarImage;
